import { toast } from 'react-toastify';
import { clearTokens } from './authUtils';

// Store reference to auth refresh callback
let authRefreshHandler = null;

export const setAuthRefreshHandler = (handler) => {
    authRefreshHandler = handler;
};

export const processErrorResponse = (error, customErrorMessage = '') => {

    const status = error?.status;
    const message = error?.message;

    if (error?.isNetworkError) {
        toast.error('Network error - Please check your connection.');
        return;
    }

    if (status !== undefined) {
        switch (status) {
            case 400:
                if (message) {
                    toast.error(message);
                } else {
                    toast.error('Something went wrong. Please try refreshing the page.');
                }
                break;

            case 401:
                // Clear tokens and trigger auth flow
                clearTokens();

                if (authRefreshHandler) {
                    // Trigger authentication flow
                    toast.warning('Session expired. Re-authenticating...');
                    authRefreshHandler().catch(() => {
                        toast.error('Authentication failed. Please reload the page.');
                        setTimeout(() => window.location.reload(), 2000);
                    });
                } else {
                    // Fallback: reload page
                    toast.error('Session expired. Please login again.');
                    setTimeout(() => window.location.reload(), 1500);
                }
                break;

            case 403:
                toast.error('You are not allowed to perform this operation.');
                break;

            case 404:
                toast.error('Something went wrong. Please try refreshing the page.');
                break;

            case 500:
            case 502:
            case 503:
            case 504:
                if (customErrorMessage) {
                    toast.error(customErrorMessage);
                } else {
                    toast.error('Internal server error.');
                }
                break;

            default:
                const msg = message || customErrorMessage || 'Something went wrong.';
                toast.error(msg);
                break;
        }
    } else {
        const msg = error?.message || customErrorMessage || 'An unexpected error occurred.';
        toast.error(msg);
    }
};
